export const DARKBG_PATHS = [
  '/',
  '/risk-exploration',
  '/map',
  '/place-new-policy',
  '/setup-producer',
  '/place-new-policy-policyholder',
];
